import { LOCATION_CHANGE } from 'connected-react-router';
import pageLoadEvent from './definitions/pageLoadEvent';

const pageLoadEvents = {
  [LOCATION_CHANGE]: pageLoadEvent(() => ({})),
};

export default pageLoadEvents;
